import useUserAndToken from '../../../../core/useUserAndToken';
import { usePwaPushNotifications } from '../hooks/usePwaPushNotifications';
import PwaPushPermissionDialog from './PwaPushPermissionDialog';

/**
 * Mount inside the authenticated app shell.
 * Soft-prompts for Web Push in standalone PWA and syncs the subscription.
 */
export function PwaPushNotifications() {
    const { user, token } = useUserAndToken();
    const { permissionDialogOpen, isSyncing, enablePush, dismissPermissionPrompt } = usePwaPushNotifications({
        user,
        token,
    });

    return (
        <PwaPushPermissionDialog
            open={permissionDialogOpen}
            busy={isSyncing}
            onEnable={() => {
                void enablePush();
            }}
            onClose={dismissPermissionPrompt}
        />
    );
}

export default PwaPushNotifications;
